module.exports = __webpack_public_path__ + "static/raiden-banner-e95184540e177b2135fa06476b5ed41e.png";